import React from 'react'

const Footer = () => {
    return (
        <div className="footer text-white text-center p-2 ">
            <p>©2021 UI Experts | All Rights Reserved</p>
            
        </div>
    )
}

export default Footer
